<script>
  import {assign} from 'lodash-es'
  import { getI18 } from '../utils/share'
  export default {
    name: 'tabs-render',
    inject: ['store'],
    props: {
      node: Object
    },
    data () {
      return {
        formData: {},
        activeTab: ''
      }
    },
    computed: {
      newProps () {
        const {props, propsFn} = this.node
        if (propsFn && typeof propsFn === 'function') {
          assign(props, propsFn())
        }
        return props
      },
      countMap () {
        const {data} = this.newProps
        const countMap = {}
        for (let k in data) {
          countMap[k] = data[k].count
        }
        return countMap
      },
      // 国际化
      title () {
        const {i18nMap, title} = this.node.info || {}
        const i18Maps = getI18(this.node.objectApiName) || {}
        return i18Maps[i18nMap?.['title_name']] || title
      }
    },
    created () {
      this.activeTab = this.store?.queryParams?.tab || this.node.defaultTab?.apiName
      // 国际化
      const i18Maps = getI18(this.node.objectApiName) || {}
      this.node.viewContent.forEach(tab => {
        tab.info.name = i18Maps[tab.info?.i18nMap?.['list_tab_name']] || tab.info.name
      })
      // viewContent
    },
    render (h) {
      const {viewContent, info = {}} = this.node
      return (
        <tabs
          v-model={this.activeTab}
          on-change={this.tabChange}
          title={this.title}
          countMap={this.countMap}
          type={info?.layoutTabType}
          hideTabs={this.newProps?.hideName || info?.hideName}
        >
          {
            viewContent.map(tab => {
              const {name, apiName, hide} = this.newProps?.data?.[tab.info.apiName] || {}
              return (
                !(hide || tab.info?.hide)
                  ? <tab-item
                    label={name || tab.info.name}
                    name={apiName || tab.info.apiName}
                  >
                    {
                      tab.slots?.content
                        ? tab.slots.content(h)
                        : (
                          tab.slots?.secondLevel
                            ? (
                              <template slot="secondLevel">
                                {tab.slots.secondLevel(h)}
                                <render viewContent={tab.viewContent}/>
                              </template>
                            )
                            : <render viewContent={tab.viewContent}/>
                        )
                    }
                  </tab-item> : ''
              )
            })
          }
        </tabs>
      )
    },
    methods: {
      tabChange (val) {
        // 业务传的
        this.node.change && this.node.change(val)
        this.store?._tabChange && this.store._tabChange(val)
      },
      forceTabChange (val) {
        this.activeTab = val
      }
    },
    mounted () {
      this.store?.saveRef && this.store.saveRef(`tabs`, this)
    }
  }
</script>
